import { Link } from 'react-router-dom';
import type { ItemAgenda as TipoItem } from '@/pages/agenda/types';
import { formatarHora } from '@/pages/agenda/utils';
import { formatarData } from '@/pages/evento/utils';

export default function ItemAgenda({ item }: { item: TipoItem }) {
  const ehEvento = item.o_que === 'evento';
  const ehRifa = item.tipo === 'rifa';
  const hora = formatarHora(new Date(item.inicio_em));

  const conteudo = (
    <>
      <span className="w-12 shrink-0 pt-0.5 text-sm font-semibold tabular-nums text-foreground-800">
        {hora}
      </span>

      <span className="mt-1.5 flex h-4 w-4 shrink-0 items-center justify-center">
        {ehEvento ? (
          <span className="h-2.5 w-2.5 rounded-full bg-primary-500" />
        ) : (
          <i className="ri-corner-down-right-line text-primary-500" />
        )}
      </span>

      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <span
            className={
              ehEvento
                ? 'text-[15px] font-bold text-foreground-950'
                : 'text-[15px] font-medium text-foreground-900'
            }
          >
            {item.nome}
          </span>
          {!ehEvento && item.evento_pai && (
            <span className="text-xs text-foreground-500">↳ {item.evento_pai}</span>
          )}
        </div>
        {item.local_nome && (
          <p className="mt-0.5 text-sm text-foreground-600">{item.local_nome}</p>
        )}
      </div>

      {ehRifa ? (
        <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-semibold text-foreground-600 sm:flex">
          Ação entre amigos · {formatarData(item.inicio_em)}
        </span>
      ) : (
        ehEvento && (
          <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors group-hover:text-primary-700 sm:flex">
            Ver evento
            <i className="ri-arrow-right-line" />
          </span>
        )
      )}
    </>
  );

  if (ehRifa) {
    return <div className="-mx-2 flex items-start gap-3 rounded-lg px-2 py-3">{conteudo}</div>;
  }

  return (
    <Link
      to={`/e/${item.slug}`}
      className="group -mx-2 flex items-start gap-3 rounded-lg px-2 py-3 transition-colors hover:bg-background-100"
    >
      {conteudo}
    </Link>
  );
}